/*
 * @Author: wangshengqiang
 * @Date: 2021-12-27 21:11:05
 * @LastEditTime: 2022-01-08 20:39:36
 * @LastEditors: wangshengqiang
 * @Description: 文件上传基础组件
 */
import React, { useEffect, useState } from 'react';
import { FilePicker, Toast, Icon } from 'zarm';
import { uploadFile } from '@/services/index.js';
import './index.less'; // accept	string	-	允许上传的附件格式
// capture	string	-	唤起的原生应用，可选值：照相机camera, 摄像机camcorder, 录音microphone
// multiple	boolean	false	是否多选
// disabled	boolean	false	是否禁用

const UploadFile = props => {
  const {
    children,
    title,
    onChange,
    value
  } = props;
  const [isUploading, setisUploading] = useState(false);
  const [files, setFiles] = useState([]);
  const [_value, setValue] = useState('');

  const onSelect = file => {
    const formData = new FormData();
    formData.append('file', file.file);
    uploadFile(formData).then(res => {
      const {
        success,
        result
      } = res;

      if (success) {
        setFiles([file]);
        setValue(result === null || result === void 0 ? void 0 : result.url);
        onChange(result === null || result === void 0 ? void 0 : result.url);
      } else {
        Toast.show(res.message || '服务异常');
      }
    });
  };

  useEffect(() => {
    if (value) {
      setValue(value);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "file-uplaod-container"
  }, /*#__PURE__*/React.createElement(FilePicker, {
    className: "file-picker-btn",
    onChange: selected => onSelect(selected),
    disabled: isUploading
  }, /*#__PURE__*/React.createElement("div", null, children)), /*#__PURE__*/React.createElement("div", {
    className: "file-uplaod-title"
  }, title, " "));
};

export default UploadFile;